<template>
    <div>
        <b-modal
            id="add-heading-popup"
            ref="modal"
            :title="title"
            size="sm"
            hide-footer
            :hide-header-close="loading"
            no-close-on-backdrop
            no-close-on-esc
            modal-class="hide-footer"
            @hidden="hideModal()"
        >
            <b-form @submit.stop.prevent="onSubmit()" @reset="hideModal">
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Title"
                            label-for="title"
                        >
                            <b-form-input
                                id="title"
                                v-model="fieldData.title"
                                v-validate="'required|max:100|min:1'"
                                type="text"
                                placeholder="Enter title"
                                autocomplete="no"
                                data-vv-name="title"
                                :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Submit"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                        :disabled="loading"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    /*
|--------------------------------------------------------------------------
| Component > props
|--------------------------------------------------------------------------
*/
    props: {
        /**
         * Value to determine the current compose mode which
         * varies between 'add' and 'edit'
         */
        title: {
            type: String,
            default: 'Add Heading',
        },
        buttonText: {
            type: String,
            default: 'Add',
        },
        route: {
            type: String,
            required: true,
        },
        currentField: {
            type: Object,
        },
        index: {
            type: Number,
        },
    }, // End of Component > props

    /*
|--------------------------------------------------------------------------
| Component > data
|--------------------------------------------------------------------------
*/

    data() {
        return {
            fieldData: this.initializeFormData(),
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        hidePopup(value) {
            if (value) {
                this.hideModal()
            }
        },
        currentField(value) {
            if (value) {
                this.fieldData = JSON.parse(JSON.stringify(value))
            }
        },
    },
    methods: {
        hideModal() {
            this.clearFormData()
            this.$emit('hide-modal')
            this.$refs.modal.hide()
        },
        initializeFormData() {
            return {
                association: null,
                isRequired: false,
                isLocked: false,
                dataSegmentId: '',
                section: '',
                sectionTitle: '',
                type: 'heading',
                sequenceNumber: 0,
                title: '',
                label: '',
                placeholder: '',
                icon: 'icon-heading',
                options: [],
                maxLength: null,
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            let self = this
            const result = await this.$validator.validateAll()
            this.fieldData.dataSegmentId = this.dataSegmentId
            this.fieldData.section = this.route
            this.fieldData.label = this.fieldData.title
            this.fieldData.sectionTitle =
                this.route == 'setup-profile' ? 'Setup Profile' : 'Account Info'

            let passing = true
            if (result) {
                if (this.$parent.formData) {
                    if (
                        this.buttonText == 'Update' &&
                        this.$parent.formData[this.index].title.toLowerCase() ==
                            self.fieldData.title.toLowerCase()
                    ) {
                        passing = true
                    } else {
                        this.$parent.formData.forEach(function(list) {
                            if (
                                list.title.toLowerCase() ==
                                self.fieldData.title.toLowerCase()
                            ) {
                                passing = false
                            }
                        })
                    }
                }
                if (passing) {
                    this.$store.commit('setLoading', true)

                    if (this.buttonText === 'Update') {
                        Object.assign(
                            this.$parent.formData[this.index],
                            this.fieldData
                        )
                        this.$store.commit(
                            'setSuccess',
                            'Field has been updated. Please click on Update Form to save the changes.'
                        )
                    } else {
                        this.$parent.formData.push(
                            JSON.parse(JSON.stringify(self.fieldData))
                        )
                        this.$store.commit(
                            'setSuccess',
                            'Field has been added. Please click on Update Form to save the changes.'
                        )
                    }

                    setTimeout(function() {
                        self.$store.commit('setChangeDetect', true)
                        self.$store.commit('setLoading', false)
                        self.$refs.modal.hide()
                        self.clearFormData()
                    }, 2000)
                } else {
                    this.$store.commit('setError', 'Heading already exists.')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.fieldData, this.initializeFormData())
        }, // End of clearFormData() method
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'dataSegmentId']),
    }, // End of Component > computed
}
</script>
